import React, { useEffect, useState, Fragment } from 'react';
import Date from '../../../../controls/Date';
import moment, { Moment } from 'moment';
import { Divider, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import Button from '../../../../components/atoms/Button/Button';
import { useModels } from '../../hooks/useModels';
import { useGetApiV1UnderwritingErrorsQuery, useLazyGetApiV1UnderwritingErrorsQuery } from '../../api';


type Props = {
    modelID: number
}

export const defaultParams: { startDate: string, endDate: string } = {
    startDate: moment().add(-3, 'day').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'day').format('YYYY-MM-DD')
}

type Inputs = {
    startDate: string
    endDate: string
}

const Errors: React.FC<Props> = ({ modelID }) => {

    const { errors: { data, isSuccess, isLoading, isFetching, refetch, ...restErrors } } = useModels();
    const [trigger, result] = useLazyGetApiV1UnderwritingErrorsQuery();
    const modelErrors = data?.entities[modelID]
    const [startDate, setStartDate] = useState<Moment | null>(moment(restErrors.originalArgs?.startDate ?? defaultParams.startDate, 'YYYY-MM-DD'));
    const [endDate, setEndDate] = useState<Moment | null>(moment(restErrors.originalArgs?.endDate ?? defaultParams.endDate, 'YYYY-MM-DD'));
    const { errors, register, handleSubmit } = useForm<Inputs>();

    async function update(d: Inputs) {

        if (startDate && endDate && result.originalArgs?.startDate !== startDate.format('YYYY-MM-DD')) {
            if (result) {
                trigger({ modelId: modelID, startDate: startDate.format('YYYY-MM-DD'), endDate: endDate.format('YYYY-MM-DD') })
            }

            return;
        }

    }

    //This is the only way I know to get the form to properly fit to the container, due to it being a plain form.
    const widthStyle = {
        width: '100%'
    }
    return (
        <form style={widthStyle} onSubmit={handleSubmit(update)}>
            <Grid container alignItems={'center'} justifyContent={'space-between'} >
                <Grid item xs={12} sm={4}>
                    <Date onChange={(e: Moment | null) => setStartDate(e)} value={startDate}
                        error={Boolean(errors.startDate)}
                        name={'startDate'}
                        helperText={errors.startDate?.message || ' '}
                        inputRef={register({ required: 'Required' })}
                        label={'Start Date'} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Date onChange={(e: Moment | null) => setEndDate(e)} value={endDate}
                        error={Boolean(errors.endDate)}
                        name={'endDate'}
                        helperText={errors.endDate?.message || ' '}
                        inputRef={register({ required: 'Required' })}
                        label={'End Date'} />
                </Grid>
                <Grid item style={{ justifyItems: 'flex-end' }}>
                    <Button type={'submit'} loading={isLoading} color={'primary'}
                        variant={'contained'} style={{ marginBottom: 20 }}>Get</Button>
                </Grid>

            </Grid>
            <Divider />
            {data && data.entities && data.entities[modelID]?.errors.map((x, i) => <Fragment key={i}>
                <Typography variant={'subtitle2'} style={{ color: '#777' }}>{moment(x.createdOn).format('MM/DD/YYYY h:mm:ss A')}</Typography>
                <div style={{ margin: '8px 0 16px 8px' }}>{x.error}</div>
                <Divider />
            </Fragment>)}
        </form>
    );
}

export default Errors;